export default class GA {

    constructor() {
        //import
        this.IMPORT = "import"
        //export
        this.EXPORT = "export"
        //search
        this.SEARCH_PLACE = "search_place"

        //print
        this.PRINT = "print"

        //marker
        this.DRAWING = "drawing"

        //search_result
        this.SEARCH_RESULT = "search_result"

        //Table
        this.TABLE = "table"

        //Map
        this.Map = "map"

        //Locate
        this.Locate = "locate"

        //IDENTIFY
        this.IDENTIFY = "identify"
    }

    init(firebase) {
        this.ga = firebase.analytics();
    }

    //SEARCH PLACE methods
    search_place_autocomplete_search(keyword) {
        this.ga.logEvent(this.SEARCH_PLACE + "::autocomplete::search"), {
            keyword: keyword
        }
    }

    search_place_autocomplete_item_click(keyword) {
        // console.log(val)
        this.ga.logEvent(this.SEARCH_PLACE + "::autocomplete_item::click"), {
            keyword: keyword
        }
    }

    search_place_search_result_query(keyword) {
        // console.log(val)
        this.ga.logEvent(this.SEARCH_PLACE + "::search_result::query"), {
            keyword: keyword
        }
    }

    //export methods
    export_open() {
        this.ga.logEvent(this.EXPORT + "::open", {});
    }

    export_submit(format, crs_option) {
        // console.log(value)
        this.ga.logEvent(this.EXPORT + "::submit", {
            format: format,
            crs_option: crs_option,
        });
    }

    export_csv() {
        this.ga.logEvent(this.EXPORT + "::export_csv", {});
    }

    export_geojson() {
        this.ga.logEvent(this.EXPORT + "::export_geojson", {});
    }

    export_kml() {
        this.ga.logEvent(this.EXPORT + "::export_kml", {});
    }

    export_gml() {
        this.ga.logEvent(this.EXPORT + "::export_gml", {});
    }

    export_submit_success() {
        this.ga.logEvent(this.EXPORT + "::submit_success", {});
    }

    export_submit_fail() {
        this.ga.logEvent(this.EXPORT + "::submit_fail", {});
    }

    //import methods
    import_open() {
        this.ga.logEvent(this.IMPORT + "::open", {});
    }

    import_submit(format, crs_option) {
        // console.log(value)
        this.ga.logEvent(this.IMPORT + "::submit", {
            format: format,
            crs_option: crs_option,
        });
    }

    import_csv() {
        this.ga.logEvent(this.IMPORT + "::import_csv", {});
    }

    import_geojson() {
        this.ga.logEvent(this.IMPORT + "::import_geojson", {});
    }

    import_kml() {
        this.ga.logEvent(this.IMPORT + "::import_kml", {});
    }

    import_gml() {
        this.ga.logEvent(this.IMPORT + "::import_gml", {});
    }

    import_submit_success() {
        this.ga.logEvent(this.IMPORT + "::submit_success", {});
    }

    import_submit_fail() {
        this.ga.logEvent(this.IMPORT + "::submit_fail", {});
    }


    //print methods
    print_click() {
        this.ga.logEvent(this.PRINT, {});
    }

    //drawing methods
    added_marker_by_drawing() {
        this.ga.logEvent(this.DRAWING + "::added_marker", {});
    }

    edited_marker_by_drawing() {
        this.ga.logEvent(this.DRAWING + "::edited_marker", {});
    }

    deleted_marker_by_drawing() {
        this.ga.logEvent(this.DRAWING + "::deleted_marker", {});
    }

    //identify methods

    identify_identify() {
        this.ga.logEvent(this.IDENTIFY + "::identify", {});
    }

    identify_click_extent() {
        this.ga.logEvent(this.IDENTIFY + "::click_extent", {});
    }

    identify_click_trash() {
        this.ga.logEvent(this.IDENTIFY + "::click_trash", {});
    }

    identify_click_add_item() {
        this.ga.logEvent(this.IDENTIFY + "::result_item::click_add_item", {});
    }

    identify_click_copy_item() {
        this.ga.logEvent(this.IDENTIFY + "::result_item::click_copy_item", {});
    }

    identify_confirmed_add_item() {
        this.ga.logEvent(this.IDENTIFY + "::result_item::confirmed_add_item", {});
    }

    identify_confirmed_copy_item() {
        this.ga.logEvent(this.IDENTIFY + "::result_item::confirmed_copy_item", {});
    }

    //search_result methods

    sr_click_extent() {
        this.ga.logEvent(this.SEARCH_RESULT + "::click_extent", {});
    }

    sr_click_trash() {
        this.ga.logEvent(this.SEARCH_RESULT + "::click_trash", {});
    }

    sr_click_result_item_zoom() {
        this.ga.logEvent(this.SEARCH_RESULT + "::result_item::click_zoom", {});
    }

    sr_click_add_item() {
        this.ga.logEvent(this.SEARCH_RESULT + "::result_item::click_add_item", {});
    }

    sr_click_copy_item() {
        this.ga.logEvent(this.SEARCH_RESULT + "::result_item::click_copy_item", {});
    }

    sr_confirmed_add_item() {
        this.ga.logEvent(this.SEARCH_RESULT + "::result_item::confirmed_add_item", {});
    }

    sr_confirmed_copy_item() {
        this.ga.logEvent(this.SEARCH_RESULT + "::result_item::confirmed_copy_item", {});
    }

    //Table Methods
    t_click_extent() {
        this.ga.logEvent(this.TABLE + "::click_extent", {});
    }

    t_confirmed_delete_all_data() {
        this.ga.logEvent(this.TABLE + "::confirmed_delete_all_data", {});
    }

    t_confirmed_delete_table_item_data() {
        this.ga.logEvent(this.TABLE + "::table_item::confirmed_delete_data", {});
    }

    t_click_table_item_zoom() {
        this.ga.logEvent(this.TABLE + "::table_item::click_zoom", {});
    }

    t_click_table_item_search_location() {
        this.ga.logEvent(this.TABLE + "::table_item::select_location", {});
    }

    //Map Methods

    m_turn_on_overlay(layer_name) {
        this.ga.logEvent(this.Map + "::turn_on_overlay", {
            layer_name: layer_name
        });
    }

    m_change_basemap(basemap_name) {
        this.ga.logEvent(this.Map + "::change_basemap", {
            //item_name: basemap_name
            basemap_name: basemap_name
        });
    }

    //Locate Methods

    l_location_found() {
        this.ga.logEvent(this.Locate + "::location_found", {})
    }

    l_location_error() {
        this.ga.logEvent(this.Locate + "::location_error", {})
    }

}